export const colours = {
  green: '#007c39',
  activeYellow: '#ffcc00',
  yellow: '#ffcc00',
  lightYellow: '#fff0b1',
  red: '#d40512',
  activeRed: '#eb131e',
  lightGrey: '#f5f5f5',
  defaultGrey: '#cccccc',
  grey: '#a2a2a2',
  white: '#fff',
  black: '#000',
};

export const scales = {
  laptop: 0.9,
  desktop: 1,
};

export const device = {
  tabletP: '(min-width: 768px)',
  tabletL: '(min-width: 1024px)',
  laptop: '(min-width: 1366px)',
  desktop: '(min-width: 1680px)',
};
